export default __webpack_public_path__ + "static/media/instacarro-logo.c9d4b37d.svg";